import axios from "axios";
import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";

import OnboardingForm from "./views/Advisors/advisorAuth/OnboardingForm.jsx";
import store from "./Redux Store/store.js";
import { getAdvisorProfileUrl } from "./utils/urls.js";
import { setUserData } from "./Redux Store/Slices/auth.js";

//* Import Components
import NotFountPage from "./views/common/NotFountPage";
import Components from "./views/Components.jsx";
import AppWrapper from "./AppWrapper.jsx";
import LeadsTab from "./views/Leads/LeadsTab.jsx";
import LeadDetails from "./views/Leads/LeadDetails.jsx";
import ProductTab from "./views/Products/ProductTab.jsx";
import ProductList from "./views/Products/ProductList.jsx";
import ProductDetail from "./views/Products/ProductDetail.jsx";
import LoginPage from "./views/Advisors/advisorAuth/LoginPage.jsx";
// import Dashboard from "./views/Dashboard/Dashboard.jsx"; // Removed dynamic import for simplicity
import ProfilePage from "./views/profile/ProfilePage.jsx";
import InvoicePage from "./views/Invoices/InvoicePage.jsx";
import InvoicePageDetails from "./views/Invoices/InvoicePageDetails.jsx";
import SubCategoryPage from "./views/Products/SubCategoryPage.jsx";
import CertificatesPage from "./views/Certificates/CertificatesPage.jsx";
import HelpCenterPage from "./views/HelpCenter/HelpCenterPage.jsx";
import TermsPage from "./views/Terms/TermsPage.jsx";
import SupportChat from "./views/Support/SupportChat.jsx";
import ProPlans from "./views/Pro/ProPlans.jsx";
import Certification from "./views/Certification/Certification.jsx";
import Referral from "./views/Referral/Referral.jsx";
import MyTasks from "./views/Tasks/MyTasks.jsx";
import PriorityLeads from "./views/Leads/PriorityLeads.jsx";
import NotificationSettings from "./views/Settings/NotificationSettings.jsx";

const { Dashboard } = await import("./views/Dashboard/Dashboard.jsx");
const { Home } = await import("./views/Home/Home.jsx");
const { Courses } = await import("./views/Course/Courses.jsx");
const { CoursesDetails } = await import("./views/Course/CoursesDetails.jsx");

async function fetchUsersData() {
  try {
    const state = store.getState();
    const user = state.auth;
    if (!user?.isAuthenticated) {
      return { status: false };
    }
    if (user?.isSkipLogin) {
      return { status: true };
    }

    const res = await axios.get(getAdvisorProfileUrl);
    // console.log("getAdvisorProfileUrl => ", res.data);

    store.dispatch(setUserData(res.data?.data));
    return { status: true };
  } catch (err) {
    return { status: false };
  }
}

const routes = createBrowserRouter([
  {
    path: "/",
    element: <AppWrapper />,
    loader: async () => {
      await fetchUsersData();
      return true;
    },
    children: [
      {
        path: "/",
        lazy: async () => {
          return { Component: Home };
        },
        // loader: async () => {
        //   store.dispatch(setHeaderTitle("Dashboard"));
        //   return null;
        // },
      },
      {
        path: "/dashboard",
        lazy: async () => {
          return { Component: Dashboard };
        },
        // loader: async () => {
        //   store.dispatch(setHeaderTitle("Dashboard"));
        //   return null;
        // },
      },
      {
        path: "/invoices",
        lazy: async () => {
          return { Component: InvoicePage }
        },
      },
      {
        path: "/invoices/details/:invoice_display_id",
        lazy: async () => {
          return { Component: InvoicePageDetails }
        },
      },
      {
        path: "/leads",
        element: <LeadsTab />,
      },
      {
        path: "/leads/details/:leadId",
        element: <LeadDetails />,
      },
      {
        path: "/products",
        element: <ProductTab />,
      },
      {
        path: "/products/sub-category/:categoryId",
        element: <SubCategoryPage />,
      },
      {
        path: "/products/list/:categoryId/:subcategoryId",
        element: <ProductList />,
      },
      {
        path: "/products/details/:productId",
        element: <ProductDetail />,
      },
      {
        path: "/courses",
        lazy: async () => {
          return { Component: Courses };
        },
      },
      {
        path: "/courses/:courseId/",
        lazy: async () => {
          return { Component: CoursesDetails };
        },
      },
      {
        path: "/profile",
        lazy: async () => {
          return { Component: ProfilePage }
        }
      },
      {
        path: "/certificates",
        element: <CertificatesPage />,
      },
      {
        path: "/help",
        element: <HelpCenterPage />,
      },
      {
        path: "/support",
        element: <SupportChat />,
      },
      {
        path: "/pro",
        element: <ProPlans />,
      },
      {
        path: "/certification",
        element: <Certification />,
      },
      {
        path: "/referral",
        element: <Referral />,
      },
      {
        path: "/tasks",
        element: <MyTasks />,
      },
      {
        path: "/priority-leads",
        element: <PriorityLeads />,
      },
      {
        path: "/notification-settings",
        element: <NotificationSettings />,
      },
      {
        path: "/terms",
        element: <TermsPage />,
      },
    ],
  },
  {
    path: "/advisor-onboarding",
    element: <OnboardingForm />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/components",
    element: <Components />,
  },
  {
    path: "*",
    element: <NotFountPage />,
  },
]);

export default routes;
